(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-new"]) return;
  try {
    
  /* ---- Sticky Header ---- */
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mq = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      this.mq.addEventListener('change', this.setHeaderHeight);
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mq.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if ([...this.predictiveSearches].some((ps) => ps.isOpen)) return;
      if (this.querySelector('.dibs-nav-wrap.is-open')) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((d) => d.close && d.close());
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  /* ---- Hover mega menu ---- */
  (function initMegaMenu() {
    const navWrap = document.querySelector('.dibs-nav-wrap');
    if (!navWrap) return;
    const canHover = window.matchMedia('(hover: hover) and (min-width: 990px)');
    const allDetails = navWrap.querySelectorAll('details');
    let closeTimer;

    const closeAll = () => {
      allDetails.forEach((d) => d.removeAttribute('open'));
      navWrap.classList.remove('is-open');
    };

    const openOne = (details) => {
      window.clearTimeout(closeTimer);
      allDetails.forEach((d) => {
        if (d !== details) d.removeAttribute('open');
      });
      details.setAttribute('open', '');
      navWrap.classList.add('is-open');
    };

    allDetails.forEach((details) => {
      details.addEventListener('mouseenter', () => {
        if (!canHover.matches) return;
        openOne(details);
      });
      details.addEventListener('toggle', () => {
        navWrap.classList.toggle('is-open', navWrap.querySelector('details[open]') !== null);
      });
    });

    navWrap.addEventListener('mouseleave', () => {
      if (!canHover.matches) return;
      closeTimer = window.setTimeout(closeAll, 120);
    });

    navWrap.addEventListener('mouseenter', () => window.clearTimeout(closeTimer));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll();
    });
    document.addEventListener('click', (e) => {
      if (!navWrap.contains(e.target)) closeAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* ── Sticky Header ── */
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mq = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      this.mq.addEventListener('change', this.setHeaderHeight);
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.mq.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if ([...this.predictiveSearches].some((ps) => ps.isOpen)) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((d) => d.close && d.close());
    }
  }
  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  /* ── Search toggle ── */
  (function () {
    document.querySelectorAll('[id^="nx-search-toggle-"]').forEach(function (btn) {
      var sid = btn.id.replace('nx-search-toggle-', '');
      var dropdown = document.getElementById('nx-search-dropdown-' + sid);
      var input = dropdown ? dropdown.querySelector('input[type="search"]') : null;
      if (!dropdown) return;
      btn.addEventListener('click', function () {
        var isOpen = dropdown.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen);
        if (isOpen && input)
          setTimeout(function () {
            input.focus();
          }, 50);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && dropdown.classList.contains('is-open')) {
          dropdown.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          btn.focus();
        }
      });
      document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target) && !btn.contains(e.target)) {
          dropdown.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    });
  })();

  /* ── Subnav dropdown close on outside click ── */
  (function () {
    document.addEventListener('click', function (e) {
      document.querySelectorAll('.nx-subnav details[open]').forEach(function (d) {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.nx-subnav details[open]').forEach(function (d) {
          d.removeAttribute('open');
        });
      }
    });
  })();

  /* ── Mobile drawer ── */
  (function () {
    var drawer = document.querySelector('.nx-drawer');
    if (!drawer) return;

    function resetPanels() {
      drawer.querySelectorAll('.nx-panel.is-open').forEach(function (p) {
        if (!p.classList.contains('nx-panel--root')) p.classList.remove('is-open');
      });
    }
    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('nx-drawer-open');
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('nx-drawer-open');
      setTimeout(resetPanels, 320);
    }

    document.querySelectorAll('[data-nx-drawer-open]').forEach(function (b) {
      b.addEventListener('click', openDrawer);
    });
    drawer.querySelectorAll('[data-nx-drawer-close]').forEach(function (b) {
      b.addEventListener('click', closeDrawer);
    });
    drawer.querySelectorAll('[data-nx-open-panel]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var t = drawer.querySelector('[data-nx-panel="' + btn.getAttribute('data-nx-open-panel') + '"]');
        if (t) {
          t.scrollTop = 0;
          t.classList.add('is-open');
        }
      });
    });
    drawer.querySelectorAll('[data-nx-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var p = btn.closest('.nx-panel');
        if (p) p.classList.remove('is-open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 990 && drawer.classList.contains('is-open')) closeDrawer();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
